<template>
  <div class="list">
    <div class="orderListT">
      <div class="orderListThead">
        <img src="static/images/left1.png"  alt class="orderListTheadReturn" @click="back" />
        <p>兑换记录</p>
        <img src="static/images/query.png"  alt class="orderListTheadQuery"/>
      </div>
      <div class="orderListTC">
        <h2>兑换次数（次）</h2>
        <h3>{{exchangeInfo.total}}</h3>
      </div>
    </div>
    <div class="orderListC">
      <div class="orderListCT">
        <h4>兑换明细</h4>
        <p>
          <img src="static/images/all.png"  alt/>
          查看全部
        </p>
      </div>

      <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
        <ul class="orderListCO">
          <li v-for="(item, index) in records" :key="index" class="orderListCOa">
            <div class="orderListCOE">
              <h4>{{item.productName  }}</h4>
              <p>{{item.createTime}}</p>
            </div>
            <p class="orderListCOP" @click="onUpdate(item)">{{item.status == 0 ? "未送达" : "已送达"}}</p>
          </li>
        </ul>
      </van-list>
    </div>

  </div>
</template>

<script>
import {gift, update} from "../api/api"
export default {
  name: 'exchange',
  data () {
    return {
      exchangeInfo: {},
      records: [],
      loading: false,
      finished: false,
      params: {
        current: 1,
        size: 10
      }
    }
  },
  mounted() {
    this.exchangeList()
  },
  methods: {
    // 返回上一页
    back() {
      this.$router.go(-1)
    },
    // 加载更多
    onLoad() {
      this.params.current ++
      this.exchangeList()
    },
    // 积分记录
    exchangeList() {
      gift(this, this.params).then(res => {
        if(res.code == 200) {
          this.exchangeInfo = res.data
          const list = res.data.page.records
          if(list == null || list.length === 0) {
            this.finished = true
            return
          }
          if (list.length < res.data.page.size) {
            this.finished = true
          }
          if (res.data.page.pages === 1) {
            this.records = list
          } else {
            this.records = this.records.concat(list)
          }
        }
      })
    },
    // 标记送达
    onUpdate(item) {
      if(item.status == 0) {
        update(this, {id: item.id}).then(res => {
          
        })
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>  
 

</style>



// WEBPACK FOOTER //
// src/components/exchange.vue